import type { ColumnsType } from 'antd/es/table';

import { WebhookInterface } from '@interface/webhook/webhook.interface';

import { DeleteWebhook } from './delete-webhook/delete-webhook';
import { EditWebhook } from './edit-webhook/edit-webhook';
import { ActionsWrapper } from './webhooks.style';

export const consumerWebhookColumns: ColumnsType<WebhookInterface> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Delivery Url',
    dataIndex: 'deliveryUrl',
    key: 'deliveryUrl',
  },
  {
    title: 'Unified Api',
    dataIndex: 'unifiedApi',
    key: 'unifiedApi',
  },
  {
    title: 'Count events',
    dataIndex: 'events',
    key: 'id',
    render: (events) => events.length,
  },
  {
    title: 'Actions',
    dataIndex: 'id',
    key: 'actions',
    render: (id) => (
      <ActionsWrapper>
        <EditWebhook id={id} />
        <DeleteWebhook id={id} />
      </ActionsWrapper>
    ),
  },
];
